export default {
  ENVIROMENT_KEYS: () => ({
    // Host url to be used to trigger carrier Api services.
    API_HOST: "api.schneider.com/external/005/carrier/wizard/",
    // Subscription key to be used to athorize the API endpoints.
    SUBSCRIPTION_KEY: "e9786ff9ec48430ba2ce85625e253f15",
    // Firebase Remote Config
    minimumFetchIntervalInSec: 0, // minimum Fetch Interval In 0 Sec

  FIREBASE_CONFIG : {
    apiKey: "AIzaSyDrR3KYz9JFF3Tfdz7oAIkBX4XqgOfhfuM",
    authDomain: "fp-userlesswizard-prd.firebaseapp.com",
    projectId: "fp-userlesswizard-prd",
    storageBucket: "fp-userlesswizard-prd.appspot.com",
    messagingSenderId: "1007793950827",
    appId: "1:1007793950827:web:f617da4029727803f6a12e",
    measurementId: "G-YEKH9R0JKS"
},
  }),
};
